import { Component, ElementRef, ViewChild } from '@angular/core';
import { NavController, NavParams, PopoverController, AlertController, ToastController, Loading, Platform, LoadingController, ModalController } from 'ionic-angular';
import { GN } from '../../gn';
import { DIC } from '../dic';
import * as moment from 'moment';
import { CalendarPage } from '../calendar/calendar';
import { PopupPage } from '../popup/popup';
import { ActionSheetController } from 'ionic-angular'
import { Camera, CameraOptions } from '@ionic-native/camera';
import { File } from '@ionic-native/file';
import { FilePath } from '@ionic-native/file-path';
import { Transfer, TransferObject } from '@ionic-native/transfer';
import { ImgcostsPage } from './imgcosts/imgcosts';
import { MatchedMakpterolRow } from './makpterol-import/vehicle-matching';
import { buildImportedFuelCost } from './makpterol-import/fuel-cost-payload';


declare var cordova: any;

/**
 * Generated class for the CostsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-costs',
  templateUrl: 'costs.html',
})
export class CostsPage {
  @ViewChild("myfile") fileInput: ElementRef;

  makpterolFile: FileList[number] = null;
  makpterolRows: MatchedMakpterolRow[] = [];
  // The vendor will be configured separately; zero was requested for now.
  private makpterolVendorId = 0;
  private makpterolSessions = new Map<string, MatchedMakpterolRow[]>();

  selectMakpterolFile(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input.files && input.files[0];
    if (!file) {
      return;
    }

    input.value = '';
    if (!/\.(xlsx|xls)$/i.test(file.name)) {
      this.toastCtrl.create({
        message: 'Please select an Excel file (.xls or .xlsx).',
        duration: 3000
      }).present();
      return;
    }

    this.openMakpterolPreview(file);
  }

  openMakpterolPreview(file: FileList[number] = this.makpterolFile) {
    if (!file) {
      return;
    }
    const key = JSON.stringify([file.name, file.size, file.lastModified]);
    const previousRows = this.makpterolSessions.get(key);
    const savedBefore = previousRows ? previousRows.filter(row => row.saveStatus === 'saved').length : 0;
    const modal = this.modalCtrl.create('MakpterolImportPage', {
      file,
      rows: previousRows,
      onRowsLoaded: (rows: MatchedMakpterolRow[]) => {
        this.makpterolFile = file;
        this.makpterolRows = rows;
        this.makpterolSessions.set(key, rows);
      },
      validateRow: (row: MatchedMakpterolRow) => buildImportedFuelCost(row, this.gn.user, this.gn.Vehicles, 18, this.makpterolVendorId),
      saveRow: (row: MatchedMakpterolRow) => this.saveImportedFuelCost(row)
    }, { cssClass: 'modal-fullscreen2', enableBackdropDismiss: false });
    modal.onDidDismiss(data => {
      if (data && data.rows && data.rows.length) {
        this.makpterolFile = file;
        this.makpterolRows = data.rows;
        if (data.rows.filter(row => row.saveStatus === 'saved').length > savedBefore) {
          const callback = this.navParams.get('cb');
          if (callback) { callback(); }
        }
      }
    });
    modal.present();
  }

  async saveImportedFuelCost(row: MatchedMakpterolRow): Promise<string | number> {
    if (row.saveStatus === 'saved') { return row.savedCostId; }
    if (row.saveStatus === 'saving' || row.saveStatus === 'unknown') {
      throw new Error('Редот веќе е испратен. Проверете го резултатот пред повторно зачувување.');
    }
    const values = buildImportedFuelCost(row, this.gn.user, this.gn.Vehicles, 18, this.makpterolVendorId);
    const payload = {};
    Object.keys(values).forEach(key => payload[key] = this.gn.crypt(values[key]));
    row.saveStatus = 'saving';
    row.saveError = '';
    return new Promise<string | number>((resolve, reject) => {
      let finished = false;
      const fail = () => {
        if (finished) { return; }
        finished = true;
        clearTimeout(timer);
        row.saveStatus = 'unknown';
        row.saveError = 'Зачувувањето не е потврдено. Проверете во трошоците пред повторен импорт на овој фајл.';
        reject(new Error(row.saveError));
      };
      const timer = setTimeout(fail, 30000);
      try {
        this.gn._Post('/api/gn/savecost', payload, response => {
          if (finished) { return; }
          if (!response || response.id == null || !isFinite(Number(response.id)) || Number(response.id) <= 0 ||
            (response.vid != null && String(response.vid) !== String(row.vehicleid)) ||
            (response.type != null && response.type !== 'fuel')) {
            fail();
            return;
          }
          finished = true;
          clearTimeout(timer);
          row.saveStatus = 'saved';
          row.savedCostId = response.id;
          resolve(response.id);
        }, 1, { retry: false, onError: fail });
      } catch (error) {
        fail();
      }
    });
  }

  _datTemp = {}
  _multi = false;
  _continue = false;
  _finish = false;
  costsArray = []
  vendorArray = []
  DriversData = []
  payArray = []
  payGArray = []
  componentArray = []
  fuelCostTypesArray = [
    { id: -1, name: '-- ' + this.dic.l["fuelType"] + ' --' },
    { id: 1, name: this.dic.l['fuel1'] },
    { id: 2, name: this.dic.l['fuel2'] },
    { id: 3, name: this.dic.l['fuel3'] },
    { id: 4, name: this.dic.l['fuel4'] },
    { id: 5, name: this.dic.l['fuel5'] }
  ]

  zacost = ''

  haveGroivo = false
  haveServis = false
  haveOther = false
  RegularS = true
  ExtrS = false
  startDate: any = new Date()
  startDateStr: any = moment(new Date()).format(this.gn.user.DFormat)
  maturCurrency: any = new Date()
  maturCurrencyStr: any = moment(new Date()).format(this.gn.user.DFormat)

  selectedTime = new Date().getHours() + 1 + ":00";

  selectedVehicleName = ''
  selectedVehicleIds = ''

  selectedExpName = ''
  selectedExpIds = ''
  Odometer = ''
  lastCurrKmDt = ''
  lastCurrKm = 0

  selectedVendorName = ''
  selectedVendorIds = ''

  selectedDDVName = '18%'
  selectedDDVIds = '18'

  selectedPTypeName = ''
  selectedPTypeIds = ''
  selectedPTypeCnt = ''

  selectedPGTypeName = ''
  selectedPGTypeIds = ''
  selectedPGTypeCnt = ''

  selectedEmplName = ''
  selectedEmplIds = ''

  costtypeid = -1

  selectedCompName = ''
  selectedCompIds = []
  selectedCompPrice = []
  selectedCompDdv = []

  selectedTypeFuelName = ''
  selectedTypeFuelIds = -1

  Ammount = ''
  Invnum = ''
  Description = ''
  prevFuel = ''
  Refuel = ''

  edittf = false;
  editid = -1;
  type = '';
  alldrivervehicle = []

  tempglobal = ''
  values: Array<string> = [];
  arrayZegin = []

  lastImage: string = null;
  imageFileName: any;
  loading: Loading;

  HaveUploadFile = false;
  serviceimg = '/';
  paymentimg = '/';
  paymentimg1 = '/';
  paymentimg2 = '/';

  paymentpdf = '/';
  paymentpdf1 = '/';
  paymentpdf2 = '/';

  mobile = false
  loadSpinner = false

  pdflink = 'https://panorama.gps.mk/costimg/pdf-s.png'
  livedashboard = 0
  dashboard = 0
  calc = false;
  calcSumm = [{ sDdv: 0, sIznosBezDdv: 0, sIznosSoDdv: 0 }]

  _continueIds = []
  calcSummCont = [{ sPrice: 0, sLit: 0 }]
  _continueData = []

  constructor(public navCtrl: NavController, public navParams: NavParams,
    public gn: GN, public dic: DIC, public popoverCtrl: PopoverController,
    public alertCtrl: AlertController, public toastCtrl: ToastController,
    public actionSheetCtrl: ActionSheetController, public platform: Platform,
    public modalCtrl: ModalController,

    private file: File,
    private filePath: FilePath,
    private transfer: Transfer,
    public loadingCtrl: LoadingController, private camera: Camera) {
    this.selectedVehicleName = '-- ' + this.dic.l["choosevehicle"] + ' --'
    this.selectedExpName = '-- ' + this.dic.l["ChooseExpense"] + ' --'
    this.selectedVendorName = '-- ' + this.dic.l["SelectVendor"] + ' --'
    this.selectedPTypeName = '-- ' + this.dic.l["select"] + ' --'

    this.selectedDDVName = '18%'
    this.selectedDDVIds = '18'

    this.selectedPGTypeName = '-- ' + this.dic.l["select"] + ' --'
    this.selectedEmplName = '-- ' + this.dic.l["SelectEmployee"] + ' --'
    this.selectedCompName = '-- ' + this.dic.l["SelectComponents"] + ' --'
    // this.selectedTypeFuelName = '-- ' + this.dic.l["fuelType"] + ' --'
    if (this.selectedTypeFuelIds == -1) {
      this.selectedTypeFuelName = '-- ' + this.dic.l["fuelType"] + ' --'

    }

    // var _that = this
    // window["onfilechatuploadpostchange"] = function (index) {
    // debugger
    //   _that.uploadImageFromDekstop(index)
    // }

    this.livedashboard = (navParams.get("livedashboard") == undefined || navParams.get("livedashboard") == null) ? 0 : navParams.get("livedashboard");
    this.dashboard = (navParams.get("dashboard") == undefined || navParams.get("dashboard") == null) ? 0 : navParams.get("dashboard");

    if (this.gn.user.driverid + '' != '-1') {
      this.selectedEmplName = this.gn.user.UserFullName;
      this.selectedEmplIds = this.gn.user.driverid + '';
      // this.selectedExpName = this.dic.l["Fuel"];
      // this.selectedExpIds = '0';
      // this.haveGroivo = true;

      for (var i = 0; i < this.gn.Vehicles.length; i++) {
        if (this.gn.Vehicles[i].driver + '' == this.gn.user.UserFullName + '') {
          this.selectedVehicleIds = this.gn.Vehicles[i].vehicleid;
          this.selectedVehicleName = '(' + this.gn.Vehicles[i].code + ') ' + this.gn.Vehicles[i].registration;
          this.getCurrkm();
        }
      }
    }

    //selectedVehicleName = ''
    // selectedVehicleIds = ''
    if (navParams.get("vid") != null) {
      this.selectedVehicleIds = navParams.get("vid")
      this.selectedVehicleName = '(' + navParams.get("code") + ') ' + navParams.get("reg")
    }
    if (navParams.get("edit")) {
      this.edittf = true;
      this.selectedVendorName = navParams.get("selectedVendorName");
      this.selectedVendorIds = navParams.get("selectedVendorIds");
      this.selectedExpName = navParams.get("selectedExpName");
      this.selectedExpIds = navParams.get("selectedExpIds");

      this.startDateStr = navParams.get("startDateStr");
      this.startDate = navParams.get("startDate");
      this.selectedTime = navParams.get("selectedTime");

      this.maturCurrencyStr = navParams.get("maturCurrencyStr");
      this.maturCurrency = navParams.get("maturCurrency");

      this.Odometer = navParams.get("Odometer");
      this.selectedPTypeName = navParams.get("selectedPTypeName");
      this.selectedPGTypeName = navParams.get("selectedPGTypeName");

      this.selectedDDVName = navParams.get("ddv") + '%';
      this.selectedDDVIds = navParams.get("ddv");

      this.Ammount = navParams.get("Ammount");
      this.Invnum = navParams.get("InvoiceNum");
      this.selectedEmplName = navParams.get("selectedEmplName");
      this.selectedEmplIds = navParams.get("selectedEmplIds");
      this.editid = navParams.get("editid");
      this.type = navParams.get("type");

      var _ext = this.getFileExtension(navParams.get("paymentimg"))
      var _ext1 = this.getFileExtension(navParams.get("paymentimg1"))
      var _ext2 = this.getFileExtension(navParams.get("paymentimg2"))

      this.paymentpdf = _ext == 'pdf' ? navParams.get("paymentimg") : '/';
      this.paymentpdf1 = _ext1 == 'pdf' ? navParams.get("paymentimg1") : '/';
      this.paymentpdf2 = _ext2 == 'pdf' ? navParams.get("paymentimg2") : '/';

      this.paymentimg = _ext == 'pdf' ? this.pdflink : navParams.get("paymentimg");
      this.paymentimg1 = _ext1 == 'pdf' ? this.pdflink : navParams.get("paymentimg1");
      this.paymentimg2 = _ext2 == 'pdf' ? this.pdflink : navParams.get("paymentimg2");

      if (this.paymentimg == '') {
        this.paymentimg = '/'
        this.paymentpdf = '/'
      }
      if (this.paymentimg1 == '') {
        this.paymentimg1 = '/'
        this.paymentpdf1 = '/'
      }
      if (this.paymentimg2 == '') {
        this.paymentimg2 = '/'
        this.paymentpdf2 = '/'
      }

      if (this.type == 'fuel') {
        this.haveGroivo = true;
        this.Refuel = navParams.get("liters");
        this.selectedTypeFuelIds = navParams.get("fuelcosttypeid");
        // console.log(this.selectedTypeFuelIds)
        if (this.selectedTypeFuelIds == -1) {
          this.selectedTypeFuelName = '-- ' + this.dic.l["fuelType"] + ' --'
        }
        if (this.selectedTypeFuelIds == 1) {
          this.selectedTypeFuelName = this.dic.l['fuel1']
        }
        if (this.selectedTypeFuelIds == 2) {
          this.selectedTypeFuelName = this.dic.l['fuel2']
        }
        if (this.selectedTypeFuelIds == 3) {
          this.selectedTypeFuelName = this.dic.l['fuel3']
        }
        if (this.selectedTypeFuelIds == 4) {
          this.selectedTypeFuelName = this.dic.l['fuel4']
        }
        if (this.selectedTypeFuelIds == 5) {
          this.selectedTypeFuelName = this.dic.l['fuel5']
        }

        // console.log(this.selectedTypeFuelIds, 'this.selectedTypeFuelIds')
      }
      if (this.type == 'service') {
        this.haveServis = true;

        if (navParams.get("typeService") == "Regular") {
          this.togglePriority('Extra', true)
        }
        else {
          this.togglePriority('Reg', true)
        }
      }


      // console.log(navParams.get("typeService"), 'ova e navparams od typeservice')
      // console.log(this.RegularS, 'RegularS')
      // console.log(this.ExtrS, 'ExtrS')

      if (this.type == 'costs') {
        this.haveOther = true;
      }
      if (this.type == 'newcosts') {
        this.costtypeid = navParams.get("costtypeid");
      }
      this.Description = navParams.get("Description")
      if (this.type == 'service' || this.haveOther == true) {
        this.selectedCompName = navParams.get("selectedCompName")
        var selectedComponents;
        if (navParams.get("selectedComponents").toString().substr(navParams.get("selectedComponents").length - 1, 1) == ";")
          selectedComponents = navParams.get("selectedComponents").toString().substr(0, navParams.get("selectedComponents").length - 1)
        else
          selectedComponents = navParams.get("selectedComponents")
        this.selectedCompIds = selectedComponents.split(";");

        var selectedCompPrice;
        if (navParams.get("selectedCompPrice").toString().substr(navParams.get("selectedCompPrice").length - 1, 1) == ";")
          selectedCompPrice = navParams.get("selectedCompPrice").toString().substr(0, navParams.get("selectedCompPrice").length - 1)
        else
          selectedCompPrice = navParams.get("selectedCompPrice")
        this.selectedCompPrice = selectedCompPrice.split(";");

        var selectedCompDdv;
        if (navParams.get("selectedCompDdv").toString().substr(navParams.get("selectedCompDdv").length - 1, 1) == ";")
          selectedCompDdv = navParams.get("selectedCompDdv").toString().substr(0, navParams.get("selectedCompDdv").length - 1)
        else
          selectedCompDdv = navParams.get("selectedCompDdv")
        this.selectedCompDdv = selectedCompDdv.split(";");
      }
      if (this.type == 'service' || this.type == 'costs') {
        var selectedserial
        if (navParams.get("selectedserial") != undefined && navParams.get("selectedserial") != null) {
          selectedserial = navParams.get("selectedserial")
          if (this.selectedCompName.split(',') != undefined && this.selectedCompName.split(',') != null) {
            // debugger
            var names = this.selectedCompName.split(',')

            var selectedserialArray = (selectedserial.length == 0 ? selectedserial : selectedserial.split(';'))

            var imagesfromservices
            if (navParams.get("selectedimages") != undefined && navParams.get("selectedimages") != null) {
              imagesfromservices = navParams.get("selectedimages")
              var selectedimagesfromservices = (imagesfromservices.length == 0 ? imagesfromservices : imagesfromservices.split(';'))
            }

            for (let i = 0; i < this.selectedCompIds.length; i++) {
              var _selectedimagesfromservices = '/'
              if (selectedimagesfromservices[i] != undefined)
                _selectedimagesfromservices = selectedimagesfromservices[i]

              var _selecteds = ''
              if (selectedserialArray[i] != undefined)
                _selecteds = selectedserialArray[i]
              this.arrayZegin.push({ id: this.selectedCompIds[i], name: names[i], serial: _selecteds, image: _selectedimagesfromservices, ammount: this.selectedCompPrice[i], ddv: (this.selectedCompDdv[i] == '' || this.selectedCompDdv[i] == null || this.selectedCompDdv[i] == undefined) ? 18 : this.selectedCompDdv[i] })
              this.values[i] = _selecteds
            }

          }
          //ako nema seriski broevi da pokaze samo za iznos i ddv
        } else {
          if (this.selectedCompName.split(',') != undefined && this.selectedCompName.split(',') != null) {
            var names = this.selectedCompName.split(',')

            for (let i = 0; i < this.selectedCompIds.length; i++) {
              this.arrayZegin.push({ id: this.selectedCompIds[i], name: names[i], serial: '', image: '/', ammount: this.selectedCompPrice[i], ddv: (this.selectedCompDdv[i] == '' || this.selectedCompDdv[i] == null || this.selectedCompDdv[i] == undefined) ? 18 : this.selectedCompDdv[i] })
              this.values[i] = ''
            }
          }
        }
        var _that = this;
        setTimeout(() => {
          _that.calcCost()
        }, 2000);
      }
    }
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad CostsPage');
    this.getCosts()
    this.getVendors()
    this.getDrivers()
    this.getPayTypes()
    this.getPayGroupTypes()
    this.getComponent()
    this.getAllDriversVehicles()
    if (window.innerWidth < 799) {
      this.mobile = true;
    }

  }


  RoundFloatCeil(_txt) {
    return Math.ceil(parseFloat(_txt + ''));
  }

  openTimePopup(_ev) {
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'time', selected: [], callback: function (_text, _ids) {
        _that.selectedTime = _text;
        _that.getCurrDriver()
      }
    });
    popover.present({
      ev: _ev
    });
  }

  openVehiclePopup(_ev) {
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'vehicles-routing', selected: [], callback: function (_text, _ids) {
        _that.selectedVehicleName = _text;
        _that.selectedVehicleIds = parseInt(_ids) + '';
        _that.getCurrkm()
        _that.changeDrivers()
        _that.getCurrDriver()
        _that.calcCost()

        if (_that.tempglobal != _that.selectedVehicleIds) {
          _that.selectedEmplName = '-- ' + _that.dic.l["SelectEmployee"] + ' --'
          _that.selectedEmplIds = ''
        }
        _that.tempglobal = parseInt(_ids) + ''
        // console.log(_that.selectedVehicleID, _that.selectedVehicleName)
      }
    });
    popover.present({
      ev: _ev
    });
  }

  getAllDriversVehicles() {
    var _that = this
    this.gn._Post('/api/gn/getallvehicledriver', { cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      console.log(_data, 'daj da vidam data')
      _that.alldrivervehicle = _data.alldrivervehicle;

      //live dashboard
      if (_that.livedashboard == 1) {
        if (_that.navParams.get("dashDriver") != '' && _that.navParams.get("dashDriver") != null && _that.navParams.get("dashDriver") != undefined) {
          _that.selectedEmplName = _that.navParams.get("dashDriver")
          _that.selectedEmplIds = _that.navParams.get("dashDid")
        }
        _that.getCurrkmNow();
      }
      //end live dashboard

      //pri edit na trosokot da gi dava samo dozvolenite vozaci, a ne site
      if (_that.edittf) {
        _that.changeDrivers();
      }
    })
  }
  getCosts() {
    var _that = this

    this.gn._Post('/api/gn/getCosts', { cid: this.gn.crypt(this.gn.user.ClientId), lang: this.gn.crypt(this.dic.Lang) }, function (_data) {
      // console.log(_data)
      for (var i = 0; i < _data.length; i++) {
        _that.costsArray.push({ costname: _data[i].costname, id: i, uid: _data[i].id, cnt: _data[i].cnt })
      }

      _that.gn._Post('/api/gn/getallcosts', { cid: _that.gn.crypt(_that.gn.user.ClientId) }, function (_data1) {
        for (var a = 0; a < _data1.length; a++) {
          if (_data1[a].name == 'fuel') _data1[a].name = _that.dic.l["Fuel"]
          if (_data1[a].name == 'service') _data1[a].name = _that.dic.l["service"]
          if (_data1[a].name == 'othercosts') _data1[a].name = _that.dic.l["iznothcosts"]
        }
        _that.gn.Costs = _data1
      })
    })
  }
  getVendors() {
    var _that = this
    var cid = this.gn.user.ClientId;
    this.gn._Get('/api/getExe/' + cid, {}, function (_data) {
      // console.log("Izvrshitel",_data);
      for (var i = 0; i < _data.length; i++) {
        _that.vendorArray.push({ vendor: _data[i].locationname, id: _data[i].id })

      }
    })
  }
  getDrivers() {
    var _that = this
    // _that.DriversData.push({id: 0, name: '-- '+this.dic.l["ChooseDriver"]+' --'})
    this.gn._Post('/api/gn/getalldrivers', { cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      for (var i = 0; i < _data.length; i++) {
        _that.DriversData.push({ id: _data[i].id, name: _data[i].fullname })

      }
      // console.log(_data)
    })
  }

  getCurrDriver() {
    var _that = this
    var _dat = {
      d: _that.gn.crypt(moment(_that.startDate).format('YYYY-MM-DD')),
      vehid: _that.gn.crypt(_that.selectedVehicleIds)
    }
    this.gn.tfBtn = true;
    this.loadSpinner = true;
    _that.gn._Post('/api/gn/getcurrdriver', _dat, function (_data) {
      _that.gn.tfBtn = false;
      _that.loadSpinner = false;

      _that.selectedEmplName = _data.drivername
      _that.selectedEmplIds = _data.driverid
    })
  }

  getCurrkm() {
    var _that = this
    var _dat = {
      d: _that.gn.crypt(moment(_that.startDate).format('YYYY-MM-DD')),
      vehid: _that.gn.crypt(_that.selectedVehicleIds)
    }
    this.gn.tfBtn = true;
    this.loadSpinner = true;
    _that.gn._Post('/api/gn/getcurrkm', _dat, function (_data) {
      _that.gn.tfBtn = false;
      _that.loadSpinner = false;
      _that.Odometer = _that.RoundFloatCeil(_data.odometer * _that.gn.user.metricvalue) + '';
      if (_data.currkmdt != '') {
        _that.lastCurrKmDt = moment(_data.currkmdt).format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat)
        _that.lastCurrKm = _data.currkm
      } else {
        _that.lastCurrKmDt = ''
        _that.lastCurrKm = 0
      }
    })
  }
  getCurrkmNow() {
    var _that = this
    var _dat = {
      d: _that.gn.crypt(moment(_that.startDate).format('YYYY-MM-DD HH:mm:ss')),
      vehid: _that.gn.crypt(_that.selectedVehicleIds)
    }
    this.gn.tfBtn = true;
    this.loadSpinner = true;
    _that.gn._Post('/api/gn/getcurrkm', _dat, function (_data) {
      _that.gn.tfBtn = false;
      _that.loadSpinner = false;
      _that.Odometer = _that.RoundFloatCeil(_data.odometer * _that.gn.user.metricvalue) + '';
      if (_data.currkmdt != '') {
        _that.lastCurrKmDt = moment(_data.currkmdt).format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat)
        _that.lastCurrKm = _data.currkm
      } else {
        _that.lastCurrKmDt = ''
        _that.lastCurrKm = 0
      }
    })
  }
  changeDrivers() {
    this.DriversData = []
    for (var i = 0; i < this.alldrivervehicle.length; i++) {
      if (this.alldrivervehicle[i].vehicleid == this.selectedVehicleIds) {
        for (var j = 0; j < this.alldrivervehicle[i].vehdriversid.length; j++) {
          this.DriversData.push({ id: this.alldrivervehicle[i].vehdriversid[j], name: this.alldrivervehicle[i].vehdriversname[j] })
        }
      }
    }
  }
  getPayTypes() {
    var _that = this;
    this.gn._Post('/api/gn/getPay', { cid: this.gn.crypt(this.gn.user.ClientId), lang: this.gn.crypt(this.dic.Lang) }, function (_data) {
      // console.log("Nachin na plakjanje", _data)
      for (var i = 0; i < _data.length; i++) {
        _that.payArray.push({ cardname: _data[i].cardname, id: i, uid: _data[i].id, cnt: _data[i]["?column?"] })
      }
      //edit od fm izvestaj
      if (_that.navParams.get("edit")) {
        for (var i = 0; i < _that.payArray.length; i++) {
          if (_that.selectedPTypeName == _that.payArray[i].cardname) {
            _that.selectedPTypeIds = _that.payArray[parseInt(i + '')].uid
            var cnt = _that.payArray[parseInt(i + '')].cnt
            if (cnt + '' == '1') {
              _that.selectedPTypeCnt = 'g'
            }
            if (cnt + '' == '2') {
              _that.selectedPTypeCnt = 'f'
            }
          }
        }
      }
    })
  }
  getPayGroupTypes() {
    var _that = this;
    _that.payGArray.push({ cardname: '/', id: 0, uid: 0, cnt: '' })

    this.gn._Post('/api/gn/getPayGroup', { cid: this.gn.crypt(this.gn.user.ClientId), lang: this.gn.crypt(this.dic.Lang) }, function (_data) {
      // console.log("Nachin na plakjanje", _data)
      for (var i = 0; i < _data.length; i++) {
        _that.payGArray.push({ cardname: _data[i].cardname, id: i + 1, uid: _data[i].id, cnt: _data[i]["?column?"] })
      }
      //edit od fm izvestaj
      if (_that.navParams.get("edit")) {
        for (var i = 0; i < _that.payGArray.length; i++) {
          if (_that.selectedPGTypeName == _that.payGArray[i].cardname) {
            _that.selectedPGTypeIds = _that.payGArray[parseInt(i + '')].uid
            var cnt = _that.payGArray[parseInt(i + '')].cnt
            if (cnt + '' == '4') {
              _that.selectedPGTypeCnt = 'k-' + _that.payGArray[parseInt(i + '')].uid
            }
          }
        }
        if (_that.selectedPGTypeName == '/' || _that.selectedPGTypeName == '') {
          _that.selectedPGTypeIds = '0'
          _that.selectedPGTypeCnt = ''
        }
      }
    })
  }
  getComponent() {
    var _that = this;
    var cid = this.gn.user.ClientId;
    this.gn._Get('/api/getComponent/' + cid, {}, function (_data) {
      // console.log("Komponenti", _data)
      for (var i = 0; i < _data.length; i++) {
        _that.componentArray.push({ componentname: _data[i].componentname, id: _data[i].id })
      }
    })
  }

  pickExpense(_ev) {
    this.calc = false;
    this.calcSumm = [{ sDdv: 0, sIznosBezDdv: 0, sIznosSoDdv: 0 }]

    this.costtypeid = -1
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'expense', selected: '', arrayData: this.costsArray, callback: function (_text, _ids) {
        _that.selectedExpName = _text
        _that.selectedExpIds = _ids
        // console.log()
        // console.log(_that.costsArray[parseInt(_ids+'')])
        //uid: 0, cnt: 1
        if (_that.costsArray[parseInt(_ids + '')].uid == 0 && _that.costsArray[parseInt(_ids + '')].cnt == 1) {
          _that.haveGroivo = true
        } else {
          _that.haveGroivo = false
        }
        if (_that.costsArray[parseInt(_ids + '')].uid == 0 && _that.costsArray[parseInt(_ids + '')].cnt == 2) {
          _that.haveServis = true
        } else {
          _that.haveServis = false
        }
        if (_that.costsArray[parseInt(_ids + '')].uid == 0 && _that.costsArray[parseInt(_ids + '')].cnt == 3) {
          _that.haveOther = true
        } else {
          _that.costtypeid = _that.costsArray[parseInt(_ids + '')].uid
          _that.haveOther = false
        }
      }
    });
    popover.present({ ev: _ev });
  }

  openDatePopup(_ev) {
    var _that = this;
    let popover = this.popoverCtrl.create(CalendarPage, {
      d: this.startDate, cb: function (d) {
        //console.log(moment(_that.startDate).format('YYYY-MM-DD'))
        _that.startDate = d;
        _that.startDateStr = moment(_that.startDate).format(_that.gn.user.DFormat)

        var _dat = {
          d: _that.gn.crypt(moment(_that.startDate).format('YYYY-MM-DD')),
          vehid: _that.gn.crypt(_that.selectedVehicleIds)
        }
        _that.gn.tfBtn = true;
        _that.loadSpinner = true;
        _that.gn._Post('/api/gn/getcurrkm', _dat, function (_data) {
          _that.gn.tfBtn = false;
          _that.loadSpinner = false;
          _that.Odometer = _that.RoundFloatCeil(_data.odometer * _that.gn.user.metricvalue) + '';
          if (_data.currkmdt != '') {
            _that.lastCurrKmDt = moment(_data.currkmdt).format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat)
            _that.lastCurrKm = _data.currkm
          } else {
            _that.lastCurrKmDt = ''
            _that.lastCurrKm = 0
          }
          _that.getCurrDriver()
        })

      }
    })
    popover.present({ ev: _ev });
  }

  openDatePopup1(_ev) {
    var _that = this;
    let popover = this.popoverCtrl.create(CalendarPage, {
      d: this.maturCurrency, cb: function (d) {
        _that.maturCurrency = d;
        _that.maturCurrencyStr = moment(_that.maturCurrency).format(_that.gn.user.DFormat)
      }
    })
    popover.present({ ev: _ev });
  }

  pickVendor(_ev) {
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'vendor', selected: '', arrayData: this.vendorArray, callback: function (_text, _ids) {
        _that.selectedVendorName = _text
        _that.selectedVendorIds = _ids
        // console.log(_that.costsArray[parseInt(_ids+'')])
      }
    });
    popover.present({ ev: _ev });
  }

  pickTypeFuelCost(_ev) {
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'typefuelcost', selected: '', arrayData: this.fuelCostTypesArray, callback: function (_text, _ids) {
        _that.selectedTypeFuelName = _text
        _that.selectedTypeFuelIds = _ids
        // console.log(_that.costsArray[parseInt(_ids+'')])
      }
    });
    // console.log(_that.selectedTypeFuelIds, '_that.selectedTypeFuelIds')
    popover.present({ ev: _ev });
  }

  pickDriver(_ev) {
    if (this.DriversData.length > 0) {
      var _that = this
      let popover = this.popoverCtrl.create(PopupPage, {
        type: 'Drivers', selected: '', arrayData: this.DriversData, callback: function (_text, _ids) {
          _that.selectedEmplName = _text
          _that.selectedEmplIds = _ids
          // console.log(_that.costsArray[parseInt(_ids+'')])
        }
      });
      popover.present({ ev: _ev });
    } else {
      const toast = this.toastCtrl.create({ message: this.dic.l["noallowdriver"], duration: 3000, position: 'top' });
      toast.present();
    }
  }

  pickDDV(_ev, _idx) {
    var _that = this

    var ddvArray = []
    ddvArray.push({ name: '0%', id: 0, uid: 0 })
    ddvArray.push({ name: '5%', id: 1, uid: 5 })
    ddvArray.push({ name: '10%', id: 2, uid: 10 })
    ddvArray.push({ name: '15%', id: 3, uid: 15 })
    ddvArray.push({ name: '18%', id: 4, uid: 18 })
    ddvArray.push({ name: '19%', id: 5, uid: 19 })
    ddvArray.push({ name: '20%', id: 6, uid: 20 })

    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'ddv', selected: '', arrayData: ddvArray, callback: function (_text, _ids) {
        if (_idx == -1) {
          _that.selectedDDVName = _text
          _that.selectedDDVIds = ddvArray[parseInt(_ids + '')].uid
        } else {
          _that.arrayZegin[_idx].ddv = ddvArray[parseInt(_ids + '')].uid
        }

        _that.calcCost();
      }
    });
    popover.present({ ev: _ev });
  }
  pickPType(_ev) {
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'PaymentType', selected: '', arrayData: this.payArray, callback: function (_text, _ids) {
        _that.selectedPTypeName = _text
        _that.selectedPTypeIds = _that.payArray[parseInt(_ids + '')].uid
        var cnt = _that.payArray[parseInt(_ids + '')].cnt
        if (cnt + '' == '1') {
          _that.selectedPTypeCnt = 'g'
        }
        if (cnt + '' == '2') {
          _that.selectedPTypeCnt = 'f'
        }
      }
    });
    popover.present({ ev: _ev });
  }
  pickPGroupType(_ev) {
    var _that = this

    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'PaymentGroupType', selected: '', arrayData: this.payGArray, callback: function (_text, _ids) {
        _that.selectedPGTypeName = _text
        _that.selectedPGTypeIds = _that.payGArray[parseInt(_ids + '')].uid
        var cnt = _that.payGArray[parseInt(_ids + '')].cnt
        if (cnt + '' == '4') {
          _that.selectedPGTypeCnt = 'k-' + _that.payGArray[parseInt(_ids + '')].uid
        }
        if (_that.selectedPGTypeName == '/' || _that.selectedPGTypeName == '') {
          _that.selectedPGTypeIds = '0'
          _that.selectedPGTypeCnt = ''
        }
      }
    });
    popover.present({ ev: _ev });
  }

  pickComponent(_ev) {
    var selC = []
    this.costtypeid = -1
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'components', selected: '', arrayData: this.componentArray, selCompId: this.selectedCompIds, callback: function (_c, _p) {
        _that.selectedCompIds = [];
        selC = [];
        _that.values = [];
        _that.selectedCompName = '';

        for (var i = 0; i < _p.length; i++) {
          if (_p[i].ch) {
            //alert(i + ' ' + _that.selectedCompIds)

            _that.selectedCompIds.push(_p[i].id)
            selC.push(_p[i].name)
            if (_that.arrayZegin.length > 0) {
              var found = false;
              for (var ii = 0; ii < _that.arrayZegin.length; ii++) {
                if (_that.arrayZegin[ii].id == _p[i].id) {
                  found = true;
                  break;
                }
              }
              if (found == false) {
                _that.arrayZegin.push({ id: _p[i].id, name: _p[i].name, serial: '', image: '/', flag: _p[i].ch, ammount: null, ddv: 18 })

              }
            } else {
              _that.arrayZegin.push({ id: _p[i].id, name: _p[i].name, serial: '', image: '/', flag: _p[i].ch, ammount: null, ddv: 18 })

            }
          } else {
            if (_that.arrayZegin.length > 0) {
              for (let j = 0; j < _that.arrayZegin.length; j++) {
                if (_p[i].id == _that.arrayZegin[j].id) {
                  _that.arrayZegin.splice(j, 1)
                }
              }
            }
          }
        }
        _that.selectedCompName = selC.join(', ')
        // for (var i = 0; i < _that.componentArray.length; i++) {
        //   _that.selectedCompIds.push()
        // }
        // alert(_c.name)
        // alert(_that.selectedCompIds)
        // alert(_that.selectedCompName)
        // alert(_that.selectedComponents)
      }
    });
    popover.present({ ev: _ev });
  }

  valChange(value: string, index: number): void {
    this.arrayZegin[index].serial = value;
  }

  togglePriority(keys: any, flag: any) {
    // console.log(keys, 'daj da vidam kluc')
    if (keys == 'Reg') {
      this.ExtrS = flag;
      this.RegularS = !this.ExtrS;
    }
    if (keys == 'Extra') {
      this.RegularS = flag;
      this.ExtrS = !this.RegularS
    }
  }


  isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  proba() {
    var st = 'Associate'
    if (this.RegularS == true) {
      st = "Regular"
    }
    console.log(st, 'daj da vidam st')
  }

  calcCost() {
    this.calcSumm = [{ sDdv: 0, sIznosBezDdv: 0, sIznosSoDdv: 0 }]

    if (this.selectedVehicleIds + '' == '') {
      let alert = this.alertCtrl.create({ message: this.dic.l["choosevehicle"], buttons: [this.dic.l['ok']] });
      alert.present();
      return
    }

    var _cnt = 0;
    for (var z = 0; z < this.arrayZegin.length; z++) {

      if (this.arrayZegin[z].ammount == '' || this.arrayZegin[z].ammount == undefined || this.arrayZegin[z].ammount == null) {
        this.arrayZegin[z].bezddv = null
        this.arrayZegin[z].ddviznos = null
      } else {
        var _istruck = this.gn.Vehicles[this.gn.VehiclesDic[this.selectedVehicleIds]].typeid + '' == '4' ? '1' : '0'


        if (_istruck == '1') {
          this.arrayZegin[z].bezddv = parseInt((this.arrayZegin[z].ammount * 100 / (100 + (parseInt(this.arrayZegin[z].ddv)))) + '')
        } else {
          this.arrayZegin[z].bezddv = parseInt(this.arrayZegin[z].ammount)
        }

        this.arrayZegin[z].ddviznos = this.arrayZegin[z].ammount - this.arrayZegin[z].bezddv

        this.calcSumm[0].sDdv += parseInt(this.arrayZegin[z].ddviznos)
        this.calcSumm[0].sIznosBezDdv += parseInt(this.arrayZegin[z].bezddv)
        this.calcSumm[0].sIznosSoDdv += parseInt(this.arrayZegin[z].ammount)

        _cnt++
      }
    }
    this.calc = true;
  }

  numberWithCommas = (x) => {
    if (x != null)
      //return parseFloat(x).toLocaleString()
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    else
      return x;
  }

  changeCalc(_e) {
    this.calcCost();
  }

  cancelCosts() {
    var cntD = 0
    var _that = this
    if (this._continueIds.length > 0) {
      for (var c = 0; c < this._continueIds.length; c++) {
        this.gn._Post('/api/gn/reports/deletefmitem', { id: this.gn.crypt(this._continueIds[c].id), table: this.gn.crypt(this._continueIds[c].type) }, function (_data) {
          cntD++
          if (cntD == _that._continueIds.length) {
            _that.navCtrl.pop()
          }
        })
      }
    } else {
      this.navCtrl.pop()
    }
  }
  continueCosts() {
    this._finish = false;
    if (this.selectedVehicleIds + '' != '') {
      this.saveCosts(1)
    }
  }

  deleteCost(_i) {
    var _that = this
    this.gn._Post('/api/gn/reports/deletefmitem', { id: this.gn.crypt(this._continueIds[_i].id), table: this.gn.crypt(this._continueIds[_i].type) }, function (_data) {
      if (_that._continueIds[_i].istruck == '1' && parseInt(_that._continueIds[_i].ddv) > 0) {
        _that.calcSummCont[0].sPrice = _that.calcSummCont[0].sPrice - _that.RoundFloat_1(_that._continueIds[_i].pricewithoutddv)
      } else {
        _that.calcSummCont[0].sPrice = _that.calcSummCont[0].sPrice - _that.RoundFloat_1(_that._continueIds[_i].price)
      }

      if (_that._continueIds[_i].type == 'fuel') {
        _that.calcSummCont[0].sLit = _that.calcSummCont[0].sLit - parseFloat(_that._continueIds[_i].lit)
      }
      _that._continueIds.splice(_i, 1);
      _that._continueData.splice(_i, 1);
    })
  }

  finishCosts() {
    if (this.selectedVehicleIds + '' != '') {
      this.saveCosts(2)
    } else {
      this._finish = true;
    }
  }

  editContCost(_type, _id, _idx) {
    this._finish = false;

    this.selectedVehicleIds = this._continueData[_idx].vehid
    this.selectedVehicleName = '(' + this.gn.Vehicles[this.gn.VehiclesDic[this.selectedVehicleIds]].code + ') ' + this.gn.Vehicles[this.gn.VehiclesDic[this.selectedVehicleIds]].registration

    this.Ammount = this._continueData[_idx].price

    var _that = this
    setTimeout(() => {
      _that.selectedDDVName = this._continueData[_idx].ddv + '%'
      _that.selectedDDVIds = this._continueData[_idx].ddv + ''

      if (_that._continueData[_idx].stype == "Regular") {
        _that.togglePriority('Extra', true)
      }
      else {
        _that.togglePriority('Reg', true)
      }

      var _ext = this._continueData[_idx].paymentimg
      var _ext1 = this._continueData[_idx].paymentimg1
      var _ext2 = this._continueData[_idx].paymentimg2

      this.paymentpdf = _ext == 'pdf' ? this._continueData[_idx].paymentimg : '/';
      this.paymentpdf1 = _ext1 == 'pdf' ? this._continueData[_idx].paymentimg1 : '/';
      this.paymentpdf2 = _ext2 == 'pdf' ? this._continueData[_idx].paymentimg2 : '/';

      this.paymentimg = _ext == 'pdf' ? this.pdflink : this._continueData[_idx].paymentimg;
      this.paymentimg1 = _ext1 == 'pdf' ? this.pdflink : this._continueData[_idx].paymentimg1;
      this.paymentimg2 = _ext2 == 'pdf' ? this.pdflink : this._continueData[_idx].paymentimg2;

      if (this.paymentimg == '') {
        this.paymentimg = '/'
        this.paymentpdf = '/'
      }
      if (this.paymentimg1 == '') {
        this.paymentimg1 = '/'
        this.paymentpdf1 = '/'
      }
      if (this.paymentimg2 == '') {
        this.paymentimg2 = '/'
        this.paymentpdf2 = '/'
      }

      if (_type == 'service' || _type == 'costs') {
        this.selectedCompName = this._continueData[_idx].selectedcompname
        this.selectedCompIds = this._continueData[_idx].selectedcompids
        this.arrayZegin = this._continueData[_idx].arrzegin
        this.values = this._continueData[_idx].arrvalues

        this.calcCost()
      }

    }, 100);

    this.Description = this._continueData[_idx].description

    if (_type == 'fuel') {
      this.Refuel = this._continueData[_idx].lit

      this.selectedTypeFuelIds = this._continueData[_idx].fuelcosttypeid
      for (var f = 0; f < this.fuelCostTypesArray.length; f++) {
        if (this.fuelCostTypesArray[f].id + '' == this._continueData[_idx].fuelcosttypeid + '')
          this.selectedTypeFuelName = this.fuelCostTypesArray[f].name
      }
    }



    //this.getCurrkm();
    this.Odometer = this._continueData[_idx].km
    this.changeDrivers()

    this.selectedEmplIds = this._continueData[_idx].driverid
    for (var d = 0; d < this.DriversData.length; d++) {
      if (this.DriversData[d].id + '' == this._continueData[_idx].driverid + '')
        this.selectedEmplName = this.DriversData[d].name
    }
  }

  saveCosts(_continue) {

    if (this._multi && this._finish) {
      var _mess = this.dic.l["SuccessfullyCost"];
      const toast = this.toastCtrl.create({ message: _mess, duration: 3000, position: 'top' });
      toast.present();
      var _cb = this.navParams.get('cb')
      if (_cb != null) {
        _cb()
      }
      this.navCtrl.pop()
      return;
    }
    //ova e za test, izbrisi na kraj
    // if (_continue == 1) {
    //   this.setWindowForNewVeh()
    //   return false;
    // }

    if (this.selectedVehicleIds + '' == '') {

      if (this.gn.user.driverid + '' != '-1') {
        let alert = this.alertCtrl.create({ message: this.dic.l["novehicleassigned"], buttons: [this.dic.l['ok']] });
        alert.present();
        return
      } else {
        let alert = this.alertCtrl.create({ message: this.dic.l["choosevehicle"], buttons: [this.dic.l['ok']] });
        alert.present();
        return
      }
    }
    if (this.selectedExpIds + '' == '') {
      let alert = this.alertCtrl.create({ message: this.dic.l["ChooseExpense"], buttons: [this.dic.l['ok']] });
      alert.present();
      return
    }

    if (this.Description + '' == '') {
      let alert = this.alertCtrl.create({ message: this.dic.l["EnterDescr"], buttons: [this.dic.l['ok']] });
      alert.present();
      return
    }
    if (this.selectedCompIds.length == 0 && (this.haveOther == true || this.haveServis == true)) {
      let alert = this.alertCtrl.create({ message: this.dic.l["SelectOneCOmp"], buttons: [this.dic.l['ok']] });
      alert.present();
      return
    }

    var _istruck = this.gn.Vehicles[this.gn.VehiclesDic[this.selectedVehicleIds]].typeid + '' == '4' ? '1' : '0'
    var cntAmm = 0
    var pricebycomp = ''
    var ddvbycomp = ''
    var _ammcomp = 0

    for (var z = 0; z < this.arrayZegin.length; z++) {
      if (this.arrayZegin[z].ammount != "" && this.arrayZegin[z].ammount != null && this.arrayZegin[z].ammount != undefined) {
        cntAmm++
        pricebycomp += this.arrayZegin[z].ammount + ';'
        ddvbycomp += this.arrayZegin[z].ddv + ';'

        if (_istruck == '1') {
          //_ammcomp += parseInt(this.arrayZegin[z].ammount) - (1 * (parseInt(this.arrayZegin[z].ddv) / 100) * parseInt(this.arrayZegin[z].ammount))
          _ammcomp += parseInt(parseInt(this.arrayZegin[z].ammount) * 100 / (100 + parseInt(this.arrayZegin[z].ddv)) + '')
        } else {
          _ammcomp += parseInt(this.arrayZegin[z].ammount)
        }
      }
    }
    //console.log('AMMOUNT ' + _ammcomp + ' ' + _istruck)

    if (pricebycomp != '')
      pricebycomp = (pricebycomp.slice(0, pricebycomp.length - 1))
    if (ddvbycomp != '')
      ddvbycomp = (ddvbycomp.slice(0, ddvbycomp.length - 1))

    //za servis i ost trosoci da ima vneseno iznos za sekoja od komponentite
    if (this.arrayZegin.length != cntAmm && (this.haveServis == true || this.haveOther == true)) {
      let alert = this.alertCtrl.create({ message: this.dic.l["EnterАmount"], buttons: [this.dic.l['ok']] });
      alert.present();
      return
    }

    if (this.Ammount + '' == '' && this.haveServis == false && this.haveOther == false) {
      let alert = this.alertCtrl.create({ message: this.dic.l["EnterАmount"], buttons: [this.dic.l['ok']] });
      alert.present();
      return
    }

    //za servis i ost trosoci nema iznos od pole tuku e suma na site iznosi od komp (so preracunato ddv - taka ke se cuva na baza, a za ddv kaj ovie dva tipa na trosoci ke se cuva 0%)
    if (this.haveServis == true || this.haveOther == true) {
      this.Ammount = _ammcomp + ''
      this.selectedDDVIds = '0'
    }


    if (this.selectedEmplIds + '' == '') {
      let alert = this.alertCtrl.create({ message: this.dic.l["EnterEmployee"], buttons: [this.dic.l['ok']] });
      alert.present();
      return
    }
    if (this.Refuel + '' == '' && this.haveGroivo == true) {
      let alert = this.alertCtrl.create({ message: this.dic.l["EnterRefuel"], buttons: [this.dic.l['ok']] });
      alert.present();
      return
    }

    if (moment(moment(this.startDate).format('YYYY-MM-DD 00:00:00')) > moment(moment(new Date()).format('YYYY-MM-DD 00:00:00'))) {
      let alert = this.alertCtrl.create({ message: this.dic.l["costLater"], buttons: [this.dic.l['ok']] });
      alert.present();
      return
    }

    if (this.Odometer + '' == '0') {
      let alert = this.alertCtrl.create({ message: this.dic.l["enterOdometer"], buttons: [this.dic.l['ok']] });
      alert.present();
      return
    }

    var joinserial = ''
    var joinimg = ''
    if ((this.gn.user.ClientId == 357 || this.gn.user.ClientId == 654) && (this.haveServis == true || this.haveOther == true)) {
      var flag = true
      var serialonly = []
      var imgonly = []

      for (let i = 0; i < this.arrayZegin.length; i++) {
        if (this.arrayZegin[i].serial.length == 0) {
          flag = false
          break
        }
        serialonly.push(this.arrayZegin[i].serial)
        imgonly.push(this.arrayZegin[i].image)
      }
      joinserial = serialonly.join(';')
      joinimg = imgonly.join(';')
      if (flag == false) {
        let alert = this.alertCtrl.create({ message: this.dic.l["enterSerial"], buttons: [this.dic.l['ok']] });
        alert.present();
        return
      }
    }

    // debugger

    var _dt = moment(this.startDate).format('YYYY-MM-DD') + ' ' + this.selectedTime + ':00';//moment(this.startDate).format(this.gn.user.DFormat)
    var _maturdt = moment(this.maturCurrency).format('YYYY-MM-DD');//moment(this.startDate).format(this.gn.user.DFormat)

    // var amn = 0.0
    // this.Ammount = this.Ammount.replace(/\D/g, '');
    // if (this.isNumber(this.Ammount)) { amn = parseFloat(this.Ammount) * this.gn.user.metriccurrencyvalue }

    var amn = 0.0
    //this.Ammount = this.Ammount.replace(/\D/g, '');
    this.Ammount = this.Ammount.toString().replace(/,/g, '.');
    if (this.Ammount.indexOf('.') != -1) {
      this.Ammount = this.Ammount.substring(0, this.Ammount.indexOf('.') + 2)
    }
    this.Ammount = this.Ammount.replace(/[^\d.-]/g, '')
    if (this.isNumber(this.Ammount)) { amn = parseFloat(this.Ammount) * this.gn.user.metriccurrencyvalue }

    // var odm = 0
    // this.Odometer = this.Odometer.replace(/\D/g, '');
    // if (this.isNumber(this.Odometer)) { odm = this.RoundFloatCeil(parseInt(this.Odometer) / this.gn.user.metricvalue) }

    var odm = 0
    //this.Odometer = this.Odometer.replace(/\D/g, '');
    this.Odometer = this.Odometer.toString().replace(/,/g, '.');
    if (this.Odometer.indexOf('.') != -1) {
      this.Odometer = this.Odometer.substring(0, this.Odometer.indexOf('.') + 2)
    }
    this.Odometer = this.Odometer.replace(/[^\d.-]/g, '')
    if (this.isNumber(this.Odometer)) { odm = this.RoundFloatCeil(parseInt(this.Odometer) / this.gn.user.metricvalue) }

    // var pt = 0
    // if (this.isNumber(this.selectedPTypeIds)){pt=parseInt(this.selectedPTypeIds)}
    var vn = 0
    if (this.isNumber(this.selectedVendorIds)) { vn = parseInt(this.selectedVendorIds) }
    if (this.editid == -1) {
      var _type = 'costs'

      if (this.haveGroivo == false && this.haveServis == false && this.haveOther == false) {
        _type = 'newcosts'
      }
      if (this.haveGroivo == true && this.haveServis == false && this.haveOther == false) {
        _type = 'fuel'
      }
      if (this.haveGroivo == false && this.haveServis == true && this.haveOther == false) {
        _type = 'service'
      }
    } else {
      _type = this.type
    }

    var _lit = 0
    //this.Refuel = this.Refuel.replace(/\D/g, '');
    this.Refuel = this.Refuel.toString().replace(/,/g, '.');
    if (this.Refuel.indexOf('.') != -1) {
      this.Refuel = this.Refuel.substring(0, this.Refuel.indexOf('.') + 3)
    }
    this.Refuel = this.Refuel.replace(/[^\d.-]/g, '')
    if (this.isNumber(this.Refuel)) { _lit = parseFloat(this.Refuel) / this.gn.user.liquidvalue }

    // var _plit = 0
    // this.prevFuel = this.prevFuel.replace(/\D/g, '');
    // if (this.isNumber(this.prevFuel)) { _plit = parseInt(this.prevFuel) }

    var _plit = 0
    //this.prevFuel = this.prevFuel.replace(/\D/g, '');
    this.prevFuel = this.prevFuel.toString().replace(/,/g, '.');
    if (this.prevFuel.indexOf('.') != -1) {
      this.prevFuel = this.prevFuel.substring(0, this.prevFuel.indexOf('.') + 2)
    }
    this.prevFuel = this.prevFuel.replace(/[^\d.-]/g, '')
    if (this.isNumber(this.prevFuel)) { _plit = parseFloat(this.prevFuel) / this.gn.user.liquidvalue }

    var st = 'Associate'
    if (this.RegularS == true) {
      st = "Regular"
    }

    var _ext = this.getFileExtension(this.paymentpdf)
    var _ext1 = this.getFileExtension(this.paymentpdf1)
    var _ext2 = this.getFileExtension(this.paymentpdf2)

    this._datTemp = {}
    var _dat = {
      cid: this.gn.crypt(this.gn.user.ClientId),
      dateTime: this.gn.crypt(_dt),
      vehid: this.gn.crypt(this.selectedVehicleIds),
      uid: this.gn.crypt(this.gn.user.UserId),
      description: this.gn.crypt(this.Description),
      components: this.gn.crypt(this.selectedCompIds.join(';')),
      price: this.gn.crypt(amn),
      km: this.gn.crypt(odm),
      pay: this.gn.crypt(this.selectedPTypeCnt),
      paygroup: this.gn.crypt(this.selectedPGTypeCnt),
      driverid: this.gn.crypt(this.selectedEmplIds),
      location: this.gn.crypt(vn),
      type: this.gn.crypt(_type),
      lit: this.gn.crypt(_lit),
      plit: this.gn.crypt(_plit),
      stype: this.gn.crypt(st),
      costtypeid: this.gn.crypt(this.costtypeid),
      editid: this.gn.crypt(this.editid),
      fuelcosttypeid: this.gn.crypt(this.selectedTypeFuelIds),
      serialnumber: this.gn.crypt(joinserial),
      images: this.gn.crypt(joinimg),
      paymentimg: this.paymentpdf == '/' ? this.gn.crypt(this.paymentimg) : this.gn.crypt(this.paymentpdf),
      paymentimg1: this.paymentpdf1 == '/' ? this.gn.crypt(this.paymentimg1) : this.gn.crypt(this.paymentpdf1),
      paymentimg2: this.paymentpdf2 == '/' ? this.gn.crypt(this.paymentimg2) : this.gn.crypt(this.paymentpdf2),

      invnum: this.gn.crypt(this.Invnum),
      maturcurrency: this.gn.crypt(_maturdt),
      ddv: this.gn.crypt(this.selectedDDVIds),
      istruck: this.gn.crypt(_istruck),

      pricebycomp: this.gn.crypt(pricebycomp),
      ddvbycomp: this.gn.crypt(ddvbycomp),

      selectedcompname: this.gn.crypt(this.selectedCompName),
      selectedcompids: this.gn.crypt(this.selectedCompIds),

      arrzegin: this.gn.crypt([]),
      arrvalues: this.gn.crypt([])
    }
    var _datTemp = {
      cid: this.gn.user.ClientId,
      dateTime: _dt,
      vehid: this.selectedVehicleIds,
      uid: this.gn.user.UserId,
      description: this.Description,
      components: this.selectedCompIds.join(';'),
      price: amn,
      km: odm,
      pay: this.selectedPTypeCnt,
      paygroup: this.selectedPGTypeCnt,
      driverid: this.selectedEmplIds,
      location: vn,
      type: _type,
      lit: _lit,
      plit: _plit,
      stype: st,
      costtypeid: this.costtypeid,
      editid: this.editid,
      fuelcosttypeid: this.selectedTypeFuelIds,
      serialnumber: joinserial,
      images: joinimg,
      paymentimg: this.paymentpdf == '/' ? this.paymentimg : this.paymentpdf,
      paymentimg1: this.paymentpdf1 == '/' ? this.paymentimg1 : this.paymentpdf1,
      paymentimg2: this.paymentpdf2 == '/' ? this.paymentimg2 : this.paymentpdf2,

      invnum: this.Invnum,
      maturcurrency: _maturdt,
      ddv: this.selectedDDVIds,
      istruck: _istruck,

      pricebycomp: pricebycomp,
      ddvbycomp: ddvbycomp,

      selectedcompname: this.selectedCompName,
      selectedcompids: this.selectedCompIds,

      arrzegin: this.arrayZegin,
      arrvalues: this.values
    }
    this._datTemp = _datTemp

    //this.gn.disableBtn();
    this.gn.tfBtn = true;
    var _that = this

    this.gn._Post('/api/gn/savecost', _dat, function (_data) {
      // let alert = _that.alertCtrl.create({message: _that.dic.l["SuccessfullyCost"], buttons: ['ok'] });
      // alert.present();


      //ako e za Prodolzi (da vnese za drugo vozilo od istata faktura) da ne go pravi ova dole 
      //odnosno prozorot da ostane otvoren samo da gi izcisti polinjata i da go markira crveno polinjata koi treba da se vnesat
      if (_continue == 0) {
        var _mess = _that.dic.l["SuccessfullyCost"];
        if (_that.editid != -1)
          _mess = _that.dic.l["SuccessfullyCostEdit"];
        const toast = _that.toastCtrl.create({ message: _mess, duration: 3000, position: 'top' });
        toast.present();

        var _cb = _that.navParams.get('cb')
        if (_cb != null) {
          _cb()
        }
        _that.navCtrl.pop()
      } else {
        if (_continue >= 1) {
          var _veh = _that.gn.Vehicles[_that.gn.VehiclesDic[_data.vid]].registration + ' (' + _that.gn.Vehicles[_that.gn.VehiclesDic[_data.vid]].code + ')'
          var _istruck = _that.gn.Vehicles[_that.gn.VehiclesDic[_data.vid]].typeid + '' == '4' ? '1' : '0'

          for (var v = 0; v < _that._continueIds.length; v++) {
            if (_that._continueIds[v].veh == _veh) {
              _that.deleteCost(v)
            }
          }

          setTimeout(() => {
            var _pricewithoutddv = -1
            if (_istruck == '1') {
              //_pricewithoutddv = _data[j].price - (1 * (_data[j].ddv / 100) * _data[j].price)
              _pricewithoutddv = parseInt(_data.price) * 100 / (100 + parseInt(_data.ddv))
            }

            if (_istruck == '1' && parseInt(_data.ddv) > 0) {
              _that.calcSummCont[0].sPrice = _that.calcSummCont[0].sPrice + _that.RoundFloat_1(_pricewithoutddv)
            } else {
              _that.calcSummCont[0].sPrice = _that.calcSummCont[0].sPrice + _that.RoundFloat_1(_data.price)
            }

            _that.calcSummCont[0].sLit += parseFloat(_data.lit)

            var _costtypenamer = ''
            for (var a = 0; a < _that.costsArray.length; a++) {
              if (_data.costtypeidr + '' == _that.costsArray[a].uid + '')
                _costtypenamer = _that.costsArray[a].costname
            }

            _that._continueIds.push({
              veh: _veh, type: _data.type, id: _data.id, costtypenamer: _costtypenamer, price: _data.price, ddv: _data.ddv, lit: _data.lit, istruck: _istruck, pricewithoutddv: _pricewithoutddv, servicetype: st, invnum: _data.invnum,
              selectedcompname: _that.selectedCompName,
              paymentimg: _that.paymentimg, paymentimg1: _that.paymentimg1, paymentimg2: _that.paymentimg2,
            })

            _that._continueData.push(_that._datTemp)

            _that.setWindowForNewVeh()
            if (_continue == 2) {
              _that._finish = true;
            }
          }, 100);

        }
      }

      _that.gn.tfBtn = false;
    })
  }


  setWindowForNewVeh() {
    this.clearForNewVeh()
  }
  clearForNewVeh() {
    this._continue = true;
    // this.haveGroivo = false
    // this.haveServis = false
    // this.haveOther = false
    // this.RegularS = true
    // this.ExtrS = false

    this.selectedVehicleName = '-- ' + this.dic.l["choosevehicle"] + ' --'
    this.selectedVehicleIds = ''

    this.Odometer = ''
    this.lastCurrKmDt = ''
    this.lastCurrKm = 0

    var _that = this
    setTimeout(() => {
      _that.selectedDDVName = '18%'
      _that.selectedDDVIds = '18'
    }, 100);

    this.selectedEmplName = '-- ' + this.dic.l["SelectEmployee"] + ' --'
    this.selectedEmplIds = ''

    this.selectedCompName = '-- ' + this.dic.l["SelectComponents"] + ' --'
    this.selectedCompIds = []
    this.selectedCompPrice = []
    this.selectedCompDdv = []

    this.selectedTypeFuelName = '-- ' + this.dic.l["fuelType"] + ' --'
    this.selectedTypeFuelIds = -1

    this.Ammount = ''
    // this.Description = ''
    this.prevFuel = ''
    this.Refuel = ''

    this.edittf = true; //da ne moze da se menuva tipot na trosokot
    this.editid = -1;
    this.type = '';

    this.tempglobal = ''
    this.values = [];
    this.arrayZegin = []

    this.lastImage = null;

    this.HaveUploadFile = false;
    this.serviceimg = '/';
    this.paymentimg = '/';
    this.paymentimg1 = '/';
    this.paymentimg2 = '/';

    this.paymentpdf = '/';
    this.paymentpdf1 = '/';
    this.paymentpdf2 = '/';

    this.mobile = false
    this.loadSpinner = false

    this.pdflink = 'https://panorama.gps.mk/costimg/pdf-s.png'
    this.calc = false;
    this.calcSumm = [{ sDdv: 0, sIznosBezDdv: 0, sIznosSoDdv: 0 }]
  }

  addExpenses() {
    var _that = this
    const prompt = this.alertCtrl.create({
      title: this.dic.l['addexpense1'],
      inputs: [
        {
          name: 'bosko',
          placeholder: this.dic.l['name2']
        },
      ],
      buttons: [
        {
          text: this.dic.l['cancel'],
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: this.dic.l['Save'],
          handler: data => {
            _that.gn._Post('/api/gn/addNewCost', { cid: _that.gn.crypt(_that.gn.user.ClientId), cost_name: _that.gn.crypt(data.bosko) }, function (_data) {
              _that.costsArray = []
              _that.getCosts()
            })
            console.log('Saved clicked');
          }
        }
      ]

    });
    prompt.present();
  }

  addVendors() {

    var _that = this
    const prompt = this.alertCtrl.create({
      title: this.dic.l['addVendor'],
      inputs: [
        {
          name: 'kocev',
          placeholder: this.dic.l['name2']
        },
      ],
      buttons: [
        {
          text: this.dic.l['cancel'],
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: this.dic.l['Save'],
          handler: data => {
            _that.gn._Post('/api/gn/addNewVendor', { cid: _that.gn.crypt(_that.gn.user.ClientId), vendor: _that.gn.crypt(data.kocev) }, function (_data) {
              _that.vendorArray = []
              _that.getVendors()

            })
            // console.log(data,cid)
            console.log('Saved clicked');
          }
        }
      ]

    });
    prompt.present();
  }
  addComponents() {
    var _that = this
    const prompt = this.alertCtrl.create({
      title: this.dic.l['addcomponent'],
      inputs: [
        {
          name: 'boskokocev',
          placeholder: this.dic.l['name2']
        },
      ],
      buttons: [
        {
          text: this.dic.l['cancel'],
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: this.dic.l['Save'],
          handler: data => {
            _that.gn._Post('/api/gn/addComponent', { cid: _that.gn.crypt(_that.gn.user.ClientId), component: _that.gn.crypt(data.boskokocev) }, function (_data) {
              _that.componentArray = []
              _that.getComponent()

            })
            // console.log(data,cid)
            console.log('Saved clicked');
          }
        }
      ]

    });
    prompt.present();
  }
  RoundFloat1(_txt) {
    return parseFloat(_txt + '').toFixed(0);
  }
  RoundFloat2(_txt) {
    return parseFloat(parseFloat(_txt + '').toFixed(2));
  }
  RoundFloat_1(_txt) {
    return parseFloat(parseFloat(_txt + '').toFixed(0));
  }

  uploadImageCost(_index, _type, _num) {
    let actionSheet = this.actionSheetCtrl.create({
      title: 'Select Image Source',
      buttons: [
        {
          text: 'Load from Library',
          handler: () => {
            this.takePicture(this.camera.PictureSourceType.PHOTOLIBRARY, _index, _type, _num);
          }
        },
        {
          text: 'Use Camera',
          handler: () => {
            this.takePicture(this.camera.PictureSourceType.CAMERA, _index, _type, _num);
          }
        },
        {
          text: 'Cancel',
          role: 'cancel'
        }
      ]
    });
    actionSheet.present();
  }

  public takePicture(sourceType, _indexi, type, _num) {
    // Create options for the Camera Dialog
    var options = {
      quality: 50,
      sourceType: sourceType,
      saveToPhotoAlbum: false,
      correctOrientation: true
    };

    // Get the data of an image
    this.camera.getPicture(options).then((imagePath) => {
      console.log(imagePath, 'imagePath daj mi paaaaaaaath')
      // Special handling for Android library
      if (this.platform.is('android') && sourceType === this.camera.PictureSourceType.PHOTOLIBRARY) {
        this.filePath.resolveNativePath(imagePath)
          .then(filePath => {
            let correctPath = filePath.substr(0, filePath.lastIndexOf('/') + 1);
            let currentName = imagePath.substring(imagePath.lastIndexOf('/') + 1, imagePath.lastIndexOf('?'));
            this.copyFileToLocalDir(correctPath, currentName, this.createFileName(), _indexi, type, _num);
          });
      } else {
        var currentName = imagePath.substr(imagePath.lastIndexOf('/') + 1);
        var correctPath = imagePath.substr(0, imagePath.lastIndexOf('/') + 1);
        this.copyFileToLocalDir(correctPath, currentName, this.createFileName(), _indexi, type, _num);
      }
    }, (err) => {
      this.presentToast('Error while selecting image.');
    });
  }

  // Copy the image to a local folder
  private copyFileToLocalDir(namePath, currentName, newFileName, _indexim, _type, _num) {
    this.file.copyFile(namePath, currentName, cordova.file.dataDirectory, newFileName).then(success => {
      this.lastImage = newFileName;
      this.uploadImage(_indexim, _type, _num)
    }, error => {
      this.presentToast('Error while storing file.');
    });
  }

  private presentToast(text) {
    let toast = this.toastCtrl.create({
      message: text,
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }
  private createFileName() {
    var d = new Date(),
      n = d.getTime(),
      newFileName = n + ".jpg";
    return newFileName;
  }

  // Always get the accurate path to your apps folder
  public pathForImage(img) {
    if (img === null) {
      return '';
    } else {
      return cordova.file.dataDirectory + img;
    }
  }

  public uploadImage(_indeximg, _type, _num) {
    // Destination URL


    // File for Upload
    var targetPath = this.pathForImage(this.lastImage);
    var url = "https://panorama.gps.mk/api/gn/uploadFile/";
    // File name only
    var filename = this.gn.rndCode() + '-' + this.gn.rndCode() + '-' + this.gn.rndCode() + this.gn.user.UserId

    var options = {
      fileKey: "file",
      fileName: filename,
      chunkedMode: false,
      mimeType: "image/jpeg",
      params: { 'fileName': filename }
    };


    const fileTransfer: TransferObject = this.transfer.create();

    this.loading = this.loadingCtrl.create({
      content: this.dic.l["Uploading"] + '...',
    });
    this.loading.present();

    // Use the FileTransfer to upload the image
    fileTransfer.upload(targetPath, url, options).then(data => {
      this.loading.dismissAll()
      this.presentToast('Image succesful uploaded.');

      if (_type == 'service' || this.haveOther == true) {
        this.arrayZegin[_indeximg].image = 'https://panorama.gps.mk/costimg/' + data.response.split('"')[3]
      }

      if (_type == 'payment') {
        if (_num == 1)
          this.paymentimg = 'https://panorama.gps.mk/costimg/' + data.response.split('"')[3]
        if (_num == 2)
          this.paymentimg1 = 'https://panorama.gps.mk/costimg/' + data.response.split('"')[3]
        if (_num == 3)
          this.paymentimg2 = 'https://panorama.gps.mk/costimg/' + data.response.split('"')[3]
      }

      console.log(data, 'daj da vidam data od upload')
      // if (_type == 'service') {
      //   _that.arrayZegin[_index].image = 'https://panorama.gps.mk/costimg/' + _uinq + '.' + _ext
      // }
      // if (_type == 'payment') {
      //   _that.paymentimg = 'https://panorama.gps.mk/costimg/' + _uinq + '.' + _ext
      // }
      // this.pd.user.photo = data.userphoto
    }, err => {
      this.loading.dismissAll()
      this.presentToast('Error while uploading file.');
    });
  }


  deleteImg(_num) {
    if (_num == 1) {
      this.paymentimg = '/'
      this.paymentpdf = '/'
    }
    if (_num == 2) {
      this.paymentimg1 = '/'
      this.paymentpdf1 = '/'
    }
    if (_num == 3) {
      this.paymentimg2 = '/'
      this.paymentpdf2 = '/'
    }
  }

  openImage(_index, imagepath, _typeimage, _num, pdfpath) {
    var _that = this
    //debugger
    let modal = this.modalCtrl.create(ImgcostsPage, {
      index: _index, image: imagepath, typeimage: _typeimage, pdf: pdfpath, cb: function (_idx, _imagepath) {
        if (_typeimage == 'zdimage') {
          _that.arrayZegin[_idx].image = _imagepath
        }
        if (_typeimage == 'payment') {
          if (_num == 1)
            _that.paymentimg = _imagepath
          if (_num == 2)
            _that.paymentimg1 = _imagepath
          if (_num == 3)
            _that.paymentimg2 = _imagepath
        }
        // _that.loadData()
      }
    });
    modal.present();

  }

  fileChange(e, idx, type, _num) {
    // debugger
    var isValidExtension = true
    //var allowedExtensions = ["png", "jpg", "jpeg", "gif", "svg", "pdf"]
    var allowedExtensions = ["png", "jpg", "jpeg", "pdf"]
    // debugger
    var fls = e.target.files
    for (var i = 0; i < fls.length; i++) {
      var _ext = this.getFileExtension(fls[i].name)
      // console.log(_ext)
      if (allowedExtensions.indexOf(_ext) == -1) { isValidExtension = false }
      if (isValidExtension == true) {
        this.uploadImageFromDekstop(idx, fls[0], type, _num)
      } else {
        const alert = this.alertCtrl.create({
          title: this.dic.l["InvalidFile"],
          subTitle: this.dic.l["FormatMustBe"] + allowedExtensions.join(', '),
          buttons: ['OK']
        });
        alert.present();
      }
    }
  }

  uploadImageFromDekstop(_index, file, _type, _num) {
    var _loader = this.loadingCtrl.create({
      content: this.dic.l["Uploading"],
      duration: 3000
    });
    _loader.present();

    var _that = this
    // var file2 = this.fileInput.nativeElement.files[0];
    // var input = <HTMLInputElement>document.getElementById('file')
    // var file = input.files[0]
    // debugger
    var reader: any = new FileReader();
    reader.onload = function (e) {
      // debugger
      // var rawData = new ArrayBuffer();
      var _data = e.target.result

      //file.size ili e.target.result.length

      // console.log(e.target.result);

      // if (e.target.result.length > 10000000) {
      //   var bytes = _that.gn.tByte(reader.result.length)
      //   const alert = _that.alertCtrl.create({
      //     title: _that.dic.l["LargeFile"],
      //     subTitle: _that.dic.l["FileMustBe"] + bytes,
      //     buttons: ['OK']
      //   });
      //   alert.present();
      //   return
      // }
      var _poz = _data.indexOf('base64,')
      var _data2 = _data.substring(_poz + 7)

      var _uinq = _that.gn.rndCode() + '-' + _that.gn.rndCode() + '-' + _that.gn.rndCode()

      var _ext = _that.getFileExtension(file.name)

      if (_ext == 'pdf' && file.size > 5000000) {
        const alert = _that.alertCtrl.create({
          title: _that.dic.l["LargeFile"],
          subTitle: _that.dic.l["FileMustBe"],
          buttons: ['OK']
        });
        alert.present();
        return
      }

      _that.gn._PostUploadFile('/api/gn/uploadtempphoto', { file: _data2, ext: _that.gn.crypt(_ext), uniq: _that.gn.crypt(_uinq) }, function (_data) {
        // debugger
        // console.log(_data, 'daj da vidam data')
        // console.log(_data.response.split('"')[3])

        if (_type == 'service' || _type == 'costs') {
          if (_that.arrayZegin[_index] != undefined)
            _that.arrayZegin[_index].image = 'https://panorama.gps.mk/costimg/' + _uinq + '.' + _ext
        }
        if (_type == 'payment') {
          if (_num == 1) {
            if (_ext == 'pdf') {
              _that.paymentimg = 'https://panorama.gps.mk/costimg/pdf-s.png'
              _that.paymentpdf = 'https://panorama.gps.mk/costimg/' + _uinq + '.' + _ext
            } else
              _that.paymentimg = 'https://panorama.gps.mk/costimg/' + _uinq + '.' + _ext
          }
          if (_num == 2) {
            if (_ext == 'pdf') {
              _that.paymentimg1 = 'https://panorama.gps.mk/costimg/pdf-s.png'
              _that.paymentpdf1 = 'https://panorama.gps.mk/costimg/' + _uinq + '.' + _ext
            } else
              _that.paymentimg1 = 'https://panorama.gps.mk/costimg/' + _uinq + '.' + _ext
          }

          if (_num == 3) {
            if (_ext == 'pdf') {
              _that.paymentimg2 = 'https://panorama.gps.mk/costimg/pdf-s.png'
              _that.paymentpdf2 = 'https://panorama.gps.mk/costimg/' + _uinq + '.' + _ext
            } else
              _that.paymentimg2 = 'https://panorama.gps.mk/costimg/' + _uinq + '.' + _ext
          }
        }

        _loader.dismiss()
        // _that.photoPath = _uinq + '.' + _ext
      })

    }

    reader.readAsDataURL(file);
  }

  uploadFileTraining() {
    this.fileInput.nativeElement.click();
    // this.fileChange(event)
  }

  getFileExtension(_fname) {
    var tmp = _fname.split('.')
    if (tmp.length > 0) {
      return tmp[tmp.length - 1].toLocaleLowerCase()
    } else {
      return ""
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/costs/costs.ts